import axiosInstance from 'api/axiosInstance';

export interface ClientEmail {
  Email: string;
}

export const getClientNotificationEmail = async (
  customerId: string | number
): Promise<string[]> => {
  try {
    const response = await axiosInstance.get(
      '/api/activityreportcontroller/GetClientNotificationEmail',
      {
        params: { customerId },
        paramsSerializer: (params) => `payload=${JSON.stringify(params)}`,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
        data: null,
      }
    );

    const data = response.data || [];

    // Extract email addresses from response
    const emails: string[] = [];
    if (Array.isArray(data)) {
      data.forEach((item: ClientEmail) => {
        if (item.Email) {
          emails.push(item.Email);
        }
      });
    }

    return emails;
  } catch (error) {
    console.error('Error fetching client notification emails:', error);
    throw error;
  }
};

export default getClientNotificationEmail;
